import { Box } from "@chakra-ui/layout";
import "./styles.css";
import SingleChat from "./SingleChat";
import { ChatState } from "../Context/ChatProvider";
import useWindowDimensions from "../../CustomHooks/useWindowdimension";
const Chatbox = ({ fetchAgain, setFetchAgain, setIsDrawerOpen ,onOpen }) => {
  const { selectedChat } = ChatState();
  const { height, width } = useWindowDimensions();

  return (
    <Box
      d={{ base: selectedChat ? "flex" : "none", md: "flex" }}
      alignItems="center"
      flexDir="column"
      p={3}
      bg="white"
      w={{ base: "100%", md: "68%" }}
      borderRadius="lg"
      borderWidth="1px"
      style={{
        height: width > 768 ? "100%" : "75vh",
        marginTop: width > 768 ? "1px" : "-34px",
      }}
    >
      <SingleChat
        fetchAgain={fetchAgain}
        setFetchAgain={setFetchAgain}
        setIsDrawerOpen={setIsDrawerOpen}
        onOpen={onOpen}
      />
    </Box>
  );
};

export default Chatbox;
